// src/contexts/SocketContext.tsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { socketService } from '../services/socket.service';
import { useAuth } from './AuthContext';

interface SocketContextType {
    isConnected: boolean;
    connect: () => void;
    disconnect: () => void;
    socketService: typeof socketService;
}

const SocketContext = createContext<SocketContextType | undefined>(undefined);

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isConnected, setIsConnected] = useState(false);
    const { isAuthenticated, isLoading, accessToken } = useAuth();

    useEffect(() => {
        console.log('🔌 SocketProvider - Auth state changed:', { isAuthenticated, isLoading });
        console.log('🔌 REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

        const handleStatus = (data: { status: string }) => {
            console.log('🔌 Socket connection status:', data.status);
            setIsConnected(data.status === 'connected');
        };
        
        socketService.on('connection:status', handleStatus);

        // Chỉ kết nối khi auth đã sẵn sàng
        if (isAuthenticated && !isLoading) {
            console.log('🟢 Auth ready, calling socket.connect()');
            socketService.disconnect();
            socketService.connect();
        } else {
            console.log('🔴 Auth not ready, disconnecting socket');
            socketService.disconnect();
        }

        return () => {
            socketService.off('connection:status', handleStatus);
        };
    }, [isAuthenticated, isLoading, accessToken]);

    const connect = () => {
        socketService.connect();
    };

    const disconnect = () => {
        socketService.disconnect();
        setIsConnected(false);
    };

    return (
        <SocketContext.Provider value={{ isConnected, connect, disconnect, socketService }}>
            {children}
        </SocketContext.Provider>
    );
};

export const useSocket = () => {
    const context = useContext(SocketContext);
    if (!context) {
        throw new Error('useSocket must be used within SocketProvider');
    }
    return context;
};
